import { useApiQuery } from 'theSource/utils';
import { RetirementContributionsResponseDto } from './utils';

export interface UseRetirementContributionsQueryProps {
  orgPlanYearId?: number;
  enrollmentContext?: string;
  lifeEventCompleted?: boolean;
  orgPlanId: number;
}

export const useRetirementContributionsQuery = ({
  orgPlanYearId,
  enrollmentContext,
  lifeEventCompleted,
  orgPlanId,
}: UseRetirementContributionsQueryProps) => {
  const {
    data: retirementContributionsData,
    isLoading,
    isFetching,
    refetch: refetchRetirementContributons,
  } = useApiQuery<RetirementContributionsResponseDto>({
    queryKey: `${orgPlanId}_retirement_planInfo`,
    endpoint: `/benefits/retirement_contributions/${orgPlanId}`,
    params: {
      org_plan_year_id: orgPlanYearId,
      enrollment_context_type: enrollmentContext,
      life_event_completed: lifeEventCompleted,
    },
  });

  return {
    retirementContributionsData,
    isLoading,
    isFetching,
    refetchRetirementContributons,
  };
};
